export default [
  {
    path: '',
    name: 'purchase list',
    component: () => import('@/views/app/purchase-draft/list/page-list.vue'),
    meta: { title: 'Daftar Pembelian' },
  },
  {
    path: ':id/edit',
    name: 'purchase edit',
    component: () => import('@/views/app/purchase-draft/edit/page-edit.vue'),
    meta: { title: 'Edit Pembelian' },
  },
  {
    path: ':id',
    name: 'purchase detail',
    component: () => import('@/views/app/purchase-draft/detail/page-detail.vue'),
    meta: { title: 'Detail Pembelian' },
  },
]
